/**
 * @generated SignedSource<<bd32e8f1b331d9ef4ca0c335597ba534>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type row_nativeIssueTable$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"issueRow_nativeIssueTable_IssueRowWithFragments_issue">;
  readonly " $fragmentType": "row_nativeIssueTable";
};
export type row_nativeIssueTable$key = {
  readonly " $data"?: row_nativeIssueTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "row_nativeIssueTable",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isInlineEditingEnabled",
          "variableName": "isInlineEditingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "issueRow_nativeIssueTable_IssueRowWithFragments_issue"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "35ed9b417cbc07970ff9e635442e6db9";

export default node;
